import React, { useState } from 'react';
import RevTargetList from '../components/RevTargetList';
import RevTargetForm from '../components/RevTargetForm';

const RevTargetSettings = () => {
  const [activeTab, setActiveTab] = useState('view');
  const [editData, setEditData] = useState(null);

  // The state is "editing" only if we are on the form tab with data
  const isEditing = activeTab === 'add' && editData !== null;

  /**
   * Prepares the form for editing by passing the full 
   * target object (including monthly values) to the form tab.
   */
  const handleEdit = (target) => {
    setEditData(target);
    setActiveTab('add'); 
  };

  /**
   * Resets the edit state and returns to the list view 
   * upon successful save or update.
   */
  const handleSuccess = () => {
    setEditData(null);
    setActiveTab('view'); 
  };

  return (
    <div className="max-w-7xl mx-auto space-y-6 p-4">
      {/* Header and Tab Navigation */}
      <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 tracking-tight">Revenue Target Configuration</h2>
          <p className="text-sm text-gray-500">Configure seasonal monthly goals for sub-counties and streams.</p>
        </div>
        
        <div className="flex bg-gray-100 p-1.5 rounded-xl w-full md:w-auto">
          <button 
            onClick={() => { setActiveTab('view'); setEditData(null); }}
            className={`flex-1 md:flex-none px-6 py-2.5 rounded-lg text-sm font-bold transition-all ${
              activeTab === 'view' ? 'bg-white shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            View Targets
          </button>
          <button 
            onClick={() => setActiveTab('add')}
            className={`flex-1 md:flex-none px-6 py-2.5 rounded-lg text-sm font-bold transition-all ${
              activeTab === 'add' ? 'bg-white shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {editData ? 'Edit Target' : 'Add New Target'}
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="transition-opacity duration-300">
        {activeTab === 'view' ? (
          <RevTargetList 
            onEdit={handleEdit} 
            isEditing={isEditing}
          />
        ) : (
          <RevTargetForm initialData={editData} onSuccess={handleSuccess} isEditing={isEditing} />
        )}
      </div>
    </div>
  );
};

export default RevTargetSettings;